import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Button } from 'antd';
import { colors } from '../../../constants/theme';

export const IconsWraper = styled('div')`
  display: flex;
  z-index: 100;
  margin-top: 14px;
  width: 100%;
  justify-content: center;
`;

export const Errors = styled('div')`
  background-color: #ffffff;
  padding: 24px;
  width: 180px;
`;

export const ImportCsvContainer = styled('div')`
  border-top: 4px solid ${colors.darkBlue};
  width: ${({ width }) => width || '180px'};
  height: 220px;
  border-radius: 3px;
  box-shadow: 0px 1px 7px 0 rgba(0, 105, 250, 0.15);
  background-color: #ffffff;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  ${props => (props.show ? 'display: none;' : '')}
`;

export const ReadyToLaunchAdvancedText = styled('div')`
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #233b69;
`;

export const ImportCsvText = styled('span')`
  display: block;
  align-self: flex-start;
  margin-left: 10px;
  font-family: Heebo;
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  text-align: left;
  color: #233b69;
`;

export const UploadLink = styled(Button)`
  margin-left: calc(50% - 47px);
`;

export const UploadSuccess = styled('div')`
  display: ${props => (props.show ? 'none' : 'block')};
  width: 100%;
  text-align: center;
  margin-top: 32px;
  font-family: Heebo;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: ${colors.greenBright};
`;

export const DownloadSample = props => (
  <a
    href={props.href}
    css={css`
      align-self: flex-end;
      margin-right: 10px;
      ${props.extraCss || ''}
    `}
    target={props.target}
  >
    {props.linkText}
  </a>
);

DownloadSample.propTypes = {
  href: PropTypes.string,
  linkText: PropTypes.string,
  target: PropTypes.string,
};

export const FlexContainer = styled.div`
  display: flex;
  ${({ flexDirection }) => (flexDirection ? `flex-direction: ${flexDirection};` : '')}
  align-items: center;
`;

export const CategoryTitle = styled.span`
  margin: 5px 0;
  font-weight: bold;
`;
